import { selectedKeys } from "@/contexts/global";
import axiosRequest from "@/utils/axios-utils";

const getCategoryProducts = async ({
    handshake,
    categoryId,
    regionId: regId,
    pageSize = 32,
    pageNo = 0,
    query = {},
    filterCodes = [],
}) => {

    // Destructure query parameters
    const { price, sort, fast_delivery, ...otherFilters } = query;

    // Parse price range
    const [minPrice, maxPrice] = price?.split(",") || [null, null];

    // Parse sort parameters
    const [sortBy = "position", sortDir = "ASC"] = sort?.split("-") || [];

    // Construct filters object
    const filters = filterCodes.reduce((acc, code) => {
        if (otherFilters[code]) {
            acc[code] = otherFilters[code].split(",");
        }
        return acc;
    }, {});

    const regionId =
        regId && regId != "NaN" && regId != "undefined" ? regId : "1101";

    // Prepare request configuration
    const config = {
        method: "get",
        url: `/facets/categoryV2/${categoryId}?${selectedKeys}`,
        ...(handshake ? {headers: {
            Authorization: `Bearer ${handshake}`,
        }} : {}),
        params: {
            pageNo,
            pageSize,
            sortBy,
            sortDir,
            minPrice,
            maxPrice,
            ...filters,
            fast_delivery: !!fast_delivery || null,
            regionId,
            select: regionId,
        },
    };

    try {
        const response = await axiosRequest(config);
        return response.data;
    } catch (err) {
        throw new Error(`Failed to fetch category products: ${err.message}`);
    }
};

export { getCategoryProducts };
